export const sxSessionObs = {
    fontWidth: '17px',
    color: '#737373'
}

export const sxBodySession = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
}

export const TitleLabel = {
    color: 'black',
    fontWeight: '600',
    height: '15px'
}

export const BoxInput = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '5px'
}
